import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import CustomTabPanel from './TabPanel.js';
import { StyledTabs, StyledTab, StyledMenu } from './Tabs.styles.js';
import IconButton from '../Button/IconButton.js';
import { StyledMenuItem } from '../PopperMenu/PopperMenu.styles.js';
const _excluded = ["color", "tabs", "iconPosition", "canDelete", "onDelete", "variant", "canAdd", "onAdd", "addLabel", "hasMoreBtn", "moreItemList", "unmountOnChangeTab", "value", "onChange", "tabLabelStyle"];
function a11yProps(index) {
  return {
    id: "simple-tab-".concat(index),
    'aria-controls': "simple-tabpanel-".concat(index)
  };
}
function Tabs(_ref) {
  let {
      color,
      tabs,
      iconPosition,
      canDelete,
      onDelete,
      variant,
      canAdd,
      onAdd,
      addLabel,
      hasMoreBtn,
      moreItemList,
      unmountOnChangeTab,
      value,
      onChange,
      tabLabelStyle
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuTabItem, setOpenMenuTabItem] = useState(null);
  const handleAddTab = () => {
    onAdd();
  };
  useEffect(() => {
    if (value >= tabs.length) {
      onChange(null, 0);
    }
  }, [tabs.length]);
  const handleOpenMenu = (event, tabItem) => {
    setAnchorEl(event.currentTarget);
    setOpenMenuTabItem(tabItem);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenuTabItem(null);
  };
  const handleMenuItemClick = menuItem => e => {
    e.stopPropagation();
    menuItem.func(e, openMenuTabItem);
    handleCloseMenu();
  };
  const renderTabLabel = tabItem => {
    const {
      label
    } = tabItem;
    if (canDelete && onDelete) {
      return /*#__PURE__*/React__default.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, label, ' ', /*#__PURE__*/React__default.createElement(IconButton, {
        sx: {
          marginLeft: '5px'
        },
        size: "16px",
        color: theme.customColors.grey[600],
        onClick: event => {
          event.stopPropagation();
          onDelete(event, tabItem);
        }
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "meta-crm-icon-ic_cancel font-size-12"
      })), ' ');
    }
    if (hasMoreBtn) {
      return /*#__PURE__*/React__default.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, label, ' ', /*#__PURE__*/React__default.createElement(IconButton, {
        sx: {
          marginLeft: '5px'
        },
        size: "20px",
        color: theme.customColors.grey[600],
        onClick: event => {
          event.stopPropagation();
          handleOpenMenu(event, tabItem);
        }
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "meta-crm-icon-ic_dots font-size-32"
      })), ' ', /*#__PURE__*/React__default.createElement(StyledMenu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: e => {
          e.stopPropagation();
          handleCloseMenu();
        },
        MenuListProps: {
          'aria-labelledby': 'basic-button'
        }
      }, moreItemList.map((item, index) => /*#__PURE__*/React__default.createElement(StyledMenuItem, {
        onClick: handleMenuItemClick(item)
        // eslint-disable-next-line react/no-array-index-key
        ,

        key: index
      }, item.children))));
    }
    return /*#__PURE__*/React__default.createElement(Box, {
      style: _objectSpread2({}, tabLabelStyle)
    }, label);
  };
  const renderAddLabel = () => /*#__PURE__*/React__default.createElement(StyledTab, {
    icon: /*#__PURE__*/React__default.createElement(IconButton, {
      size: "16px",
      color: theme.customColors.purple[600]
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "meta-crm-icon-ic_add font-size-12"
    })),
    sx: {
      color: theme.customColors.purple[600],
      opacity: 1
    },
    iconPosition: "start",
    label: addLabel || 'add item',
    key: "add",
    onClick: handleAddTab
  });
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      borderBottom: 1,
      borderColor: theme.customColors.grey[300],
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(StyledTabs, _extends({}, otherProps, {
    value: value,
    onChange: onChange,
    indicatorColor: color,
    variant: variant,
    allowScrollButtonsMobile: true
  }), tabs.map((tabItem, index) => /*#__PURE__*/React__default.createElement(StyledTab, _extends({
    key: tabItem._id || index,
    label: renderTabLabel(tabItem),
    icon: tabItem.icon,
    iconPosition: iconPosition,
    disableRipple: true,
    disabled: tabItem.disabled
  }, a11yProps(index))))), canAdd && renderAddLabel()), tabs.map((tabItem, index) => /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default.createElement(CustomTabPanel, {
    value: value,
    index: index,
    key: tabItem._id || index,
    unmountOnChangeTab: unmountOnChangeTab
  }, tabItem.content)));
}
Tabs.propTypes = {
  iconPosition: PropTypes.oneOf(['top', 'start', 'end', 'bottom']),
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'warning']),
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  canAdd: PropTypes.bool,
  onAdd: PropTypes.func,
  addLabel: PropTypes.string,
  hasMoreBtn: PropTypes.bool,
  moreItemList: PropTypes.arrayOf(PropTypes.shape({})),
  unmountOnChangeTab: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard']),
  tabLabelStyle: PropTypes.shape({})
};
Tabs.defaultProps = {
  iconPosition: 'start',
  tabs: [],
  color: 'secondary',
  canDelete: false,
  onDelete: null,
  canAdd: false,
  onAdd: null,
  addLabel: null,
  hasMoreBtn: false,
  moreItemList: null,
  unmountOnChangeTab: true,
  value: 0,
  onChange: null,
  variant: 'scrollable',
  tabLabelStyle: {}
};
export { Tabs as default };